export function buildE2nApiTitle(suffix?: string): string {
  return suffix ? `E2N API – ${suffix}` : 'E2N API';
}
